import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import CreateGroupModal from "../../Modals/CreateGroupModal";
import { BsThreeDots } from "react-icons/bs";
import Swal from "sweetalert2";

const Group = () => {
  const [isloading, setIsLoading]= useState(false);
  const [value, setValue] = React.useState("1");
  const [modalOpen, setModalOpen] = useState(false);
  const [invitationcount, setInvitationCount] = useState("");
  const [groups, setGroups] = useState([]);
  const [sendRequests, setSendRequests] = useState([]);
  const [recievedRequests, setRecievedRequests] = useState([]);
  const [showDropdown, setShowDropdown] = useState(null); 
  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const tabs = [
    { label: "Your groups", value: "1" },
    { label: "Requested", value: "2" },
  ];
  useEffect(() => {
    getgroups();
    getSendRequests();
  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getgroups = async () => {
    setIsLoading(true); 
    const token = Cookies.get("token");
  
    try {
      const result = await axios.get(BaseUrl + "getgroups", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
  
      if (result.data.status === 200) {
        setGroups(result.data.data.groups);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setIsLoading(false); 
    }
  };
  const getSendRequests = async () => {
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getrequestedgroups", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setRecievedRequests(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLeaveGroup = async (groupId) => {
    const token = Cookies.get("token");
    try {
      const result = await axios.post(
        BaseUrl + `leavegroup/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (result.data.status === 200) {
        setGroups(prevGroups => prevGroups.filter(group => group.id !== groupId));
        Swal.fire({
                 icon: 'success',
                 title: 'You have left the group successfully',
                 toast: true,
                 position: 'top-end',
                 showConfirmButton: false,
                 timer: 3000,
                 timerProgressBar: true,
               });
      }else {
        Swal.fire({
          icon: "error",
          title: "Failed to leave the group",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error leaving group:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to left the group",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-16 h-screen ">
          <div className="container mx-auto flex flex-col lg:flex-row gap-4 py-4 px-4  sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4 ">
              <div className="bg-white border border-gray-300 rounded-lg shadow mb-4">
                <div className="">
                  <div className="flex">
                    <Box sx={{ width: "100%", typography: "body1" }}>
                      <TabContext value={value}>
                        <Box
                          className="flex justify-between "
                          sx={{ borderBottom: 1, borderColor: "divider" }}
                        >
                          <TabList
                            onChange={handleChange}
                            aria-label="Dynamic Tabs Example"
                            textColor="primary"
                            indicatorColor="primary"
                          >
                            {tabs.map((tab) => (
                              <Tab
                                key={tab.value}
                                label={tab.label}
                                value={tab.value}
                                sx={{
                                  color:
                                    value === tab.value ? "#1976D2" : "#757575",
                                  fontWeight:
                                    value === tab.value ? "bold" : "normal",
                                  fontSize: "16px",
                                  mx: 2,
                                  textTransform: "capitalize",
                                  // borderBottom: value === tab.value ? "3px solid green" : "none",
                                  // "&.Mui-selected": {
                                  //   color: "green",
                                  // },
                                  "&:hover": {
                                    backgroundColor: "#F3F4F6",
                                  },
                                }}
                              />
                            ))}
                          </TabList>
                          <div>
                            <button
                              className="border border-solid border-blue-500 text-md text-blue-500 mt-[4px] mr-8 px-4 py-1 font-medium rounded-full hover:border-blue-800 hover:text-blue-800 hover:border-2 hover:font-bold"
                              onClick={() => setModalOpen(true)}
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                            >
                              Create group
                            </button>
                          </div>
                        </Box>

                        <TabPanel value="1">
                          {groups && groups.length > 0 ? (
                            <div>
                              {groups.map((request, index) => (
                                <div
                                  key={index}
                                  className="flex justify-between px-4 border-b border-gray-200 "
                                >
                                  <div className="flex items-center gap-4">
                                    <img
                                      src={
                                        request.image !== null
                                          ? request.image
                                          : "/Images/user-img.jpg"
                                      }
                                      alt="Profile picture"
                                      className="size-20   border-4 border-white"
                                    />
                                    <div className="flex gap-5 ">
                                      <div className="flex flex-col">
                                        <Link to={`/groups/${request.slug}`}>
                                          <p className="text-gray-800 leading-none  text-lg font-semibold">
                                            {request.group_name}
                                          </p>
                                        </Link>
                                        <p className="text-gray-500 text-sm">
                                          {request.members_count} members
                                        </p>
                                      </div>
                                      {request.is_owner && (
                                        <p className="text-gray-500 leading-none h-5 px-2 text-lg font-semibold bg-gray-100">
                                          owner
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-center justify-between gap-2 relative">
                                    <button
                                      className="flex items-center justify-between gap-1 px-2 py-2 text-2xl text-gray-600 rounded-full hover:text-gray-700 hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowDropdown(
                                          showDropdown === index ? null : index
                                        );
                                      }}
                                    >
                                      <BsThreeDots />
                                    </button>

                                    {showDropdown === index && (
                                      <div
                                        ref={dropdownRef}
                                        className="absolute p-1 right-2 top-12 z-10 bg-white border border-gray-200 text-sm shadow-lg rounded-b-md rounded-tl-md w-48 overflow-hidden"
                                      >
                                        <button
                                          className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                                          onClick={() =>
                                            handleLeaveGroup(request.id)
                                          }
                                        >
                                          Leave this group
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full gap-2 h-80 flex flex-col items-center justify-center">
                              <img
                                src="/Images/group/Discover-Img 1.png"
                                alt="No data"
                                className=""
                              />
                              <p className="text-gray-800 text-2xl font-semibold">
                                Discover groups
                              </p>
                              <p className="text-gray-500 w-96 text-center">
                                Find other trusted communities that share and
                                support your goals.
                              </p>
                              <button className="border border-solid border-blue-500 text-md text-blue-500 mt-[4px] mr-8 px-4 py-1 font-medium rounded-full hover:border-blue-800 hover:text-blue-800 hover:border-2 hover:font-bold">
                                <Link to={"/groups/discover"}>
                                  Discover groups
                                </Link>
                              </button>
                            </div>
                          )}
                        </TabPanel>

                        <TabPanel value="2">
                          {sendRequests && sendRequests.length > 0 ? (
                            <div>
                              {sendRequests.map((request, index) => (
                                <div
                                  key={index}
                                  className="flex justify-between px-4 border-b border-gray-200 "
                                >
                                  <div className="flex items-center gap-4">
                                    <img
                                      src={request.image}
                                      alt="Profile picture"
                                      className="size-24 rounded-full border-4 border-white"
                                    />
                                    <div>
                                      <p className="text-gray-800 text-lg font-semibold">
                                        {request.group_name}
                                      </p>
                                      <p className="text-gray-500">
                                        {request.members_count} members
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex items-center justify-between gap-2">
                                    <button
                                      className="flex items-center justify-between gap-1 px-4 py-1 text-gray-600 rounded-full hover:text-gray-700 hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                      onClick={() => handleDecline(request.id)}
                                    >
                                      withdraw
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full gap-2 h-80 flex flex-col items-center justify-center">
                              <img
                                src="/Images/group/Discover-Img 1.png"
                                alt="No data"
                                className=""
                              />
                              <p className="text-gray-800 text-2xl font-semibold">
                                Discover groups
                              </p>
                              <p className="text-gray-500 w-96 text-center">
                                Find other trusted communities that share and
                                support your goals.
                              </p>
                              <button className="border border-solid border-blue-500 text-md text-blue-500 mt-[4px] mr-8 px-4 py-1 font-medium rounded-full hover:border-blue-800 hover:text-blue-800 hover:border-2 hover:font-bold">
                                <Link to={"/groups/discover"}>
                                  Discover groups
                                </Link>
                              </button>
                            </div>
                          )}
                        </TabPanel>
                      </TabContext>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/4 ">
              <img
                src="https://placehold.co/200x200"
                alt="Profile picture"
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <div className=" text-center py-4 mt-8  border-t border-gray-300">
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-4">
                  <Link to="#" className="hover:underline">
                    About
                  </Link>
                  <Link to="#" className="hover:underline">
                    Help Center
                  </Link>
                  <Link to="#" className="hover:underline">
                    Privacy & Terms
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Ad Choices
                  </Link>
                  <i className="fas fa-caret-down"></i>
                  <Link to="#" className="hover:underline">
                    Ad Choices
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Advertising
                  </Link>
                  <Link to="#" className="hover:underline">
                    Business Services
                  </Link>
                  <i className="fas fa-caret-down"></i>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Get the LinkedIn app
                  </Link>
                  <Link to="#" className="hover:underline">
                    More
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center items-center mt-4">
                  <img
                    src="/Images/logo/ls-linked-logo.png"
                    alt="LinkedIn logo"
                    className="mr-2"
                  />
                  <span className="text-sm text-gray-600">
                    LS-LinkedIn Corporation © 2025
                  </span>
                </div>
              </div>
            </div>
          </div>
          <CreateGroupModal
            modalOpen={modalOpen}
            closeModal={() => setModalOpen(false)}
            onGroupCreated={getgroups}
          />
        </div>
      )}
    </>
  );
};

export default Group;
